const Forms = () => {
  return <div className="min-h-full w-full bg-indigo-500">Forms page</div>;
};

export default Forms;
